import WidgetUrlInput from './WidgetUrlInput.component';

export default WidgetUrlInput;